import { useWizard } from "react-use-wizard";
import tradeInSteps from "./tradeInSteps";
import {
  TKeyOfDataWizardTradeIn,
  TNumberKeysOfIFillDataWizardTradeIn,
} from "..";
import BaseStep from "../../../../../shared/wizard/steps/baseStep";
import InputNumber from "../../../../../ui/input/input-number";
import styles from "./styles.module.scss";

interface ITradeInStep_3 {
  isNextStepDisabled: boolean;
  data: number | null;
  onChange: (data: number, key: TNumberKeysOfIFillDataWizardTradeIn) => void;
  onReset: (key: TKeyOfDataWizardTradeIn[]) => void;
}

const TradeInStep_3 = ({
  isNextStepDisabled,
  data,
  onChange,
  onReset,
}: ITradeInStep_3) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(tradeInSteps.step_2.step);
    onReset(["apartmentNumber"]);
  };

  const handleNexStep = () => {
    goToStep(tradeInSteps.step_4.step);
  };

  return (
    <div>
      <BaseStep
        counterPage={{
          current: tradeInSteps.step_3.page,
          max: tradeInSteps.step_3.maxPage,
        }}
        prevStep={handlePrevStep}
        nextStep={handleNexStep}
        text="Укажите номер квартиры: "
        isNextStepDisabled={isNextStepDisabled}
      >
        <div>
          <InputNumber
            value={data ? String(data) : ""}
            onChange={(value) => onChange(Number(value), "apartmentNumber")}
            label="Номер квартиры"
            placeholder="Например: 42"
            mode="apartment"
            isMainPlaceholder
          />
          <div className={styles.tradeInStep_3__text}>
            Эти данные необходимы для проверки, они не будут опубликованы в
            каких-либо открытых источниках
          </div>
        </div>
      </BaseStep>
    </div>
  );
};

export default TradeInStep_3;
